import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../../../core/services/api.config';
import {
  CreateServiceRequest,
  CreateServiceResponse,
  DisableServiceResponse,
  ListServicesResponse,
} from '../models/service.models';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  listServices(includeInactive = false): Observable<ListServicesResponse> {
    const params = includeInactive
      ? new HttpParams().set('includeInactive', 'true')
      : undefined;

    return this.http.get<ListServicesResponse>(`${this.apiBaseUrl}/services`, {
      withCredentials: true,
      params,
    });
  }

  createService(payload: CreateServiceRequest): Observable<CreateServiceResponse> {
    return this.http.post<CreateServiceResponse>(`${this.apiBaseUrl}/services`, payload, {
      withCredentials: true,
    });
  }

  disableService(serviceId: number): Observable<DisableServiceResponse> {
    return this.http.post<DisableServiceResponse>(
      `${this.apiBaseUrl}/services/${serviceId}/disable`,
      {},
      { withCredentials: true },
    );
  }
}
